module.exports = __webpack_public_path__ + "static/img/logo1.ee624d12.png";